const pages = {
  auth: {
    root: 'auth',
    login: {
      name: 'login',
      path: '/auth/login',
    },
    register: {
      name: 'register',
      path: '/auth/register',
    },
  },
  home: {
    name: 'home',
    path: '/home',
  },
  dashboard: {
    name: 'dashboard',
    path: '/dashboard',
  },
  application: {
    name: 'applications',
    path: '/applications',
    view: {
      name: 'view-application',
      path: '/applications/:id',
    },
    update: {
      name: 'update-application',
      path: '/applications/:id/update',
    },
  },
  utility: {
    name: 'utilities',
    path: '/utilities',
    create: {
      name: 'create-utility',
      path: '/utilities/create',
    },
    view: {
      name: 'view-utility',
      path: '/utilities/:id',
    },
    update: {
      name: 'update-utility',
      path: '/utilities/:id/update',
    },
  },
  zones: {
    name: 'zones',
    path: '/zones',
    create: {
      name: 'create-zone',
      path: '/zones/create',
    },
    view: {
      name: 'view-zone',
      path: '/zones/:id',
    },
    update: {
      name: 'update-zone',
      path: '/zones/:id/update',
    },
  },
  applicationGroup: {
    name: 'application-groups',
    path: '/application-groups',
    create: {
      name: 'create-application-group',
      path: '/application-groups/create',
    },
    view: {
      name: 'view-application-group',
      path: '/application-groups/:id',
    },
    update: {
      name: 'update-application-group',
      path: '/application-groups/:id/update',
    },
  },
  accounts: {
    name: 'accounts',
    path: '/accounts',
    create: {
      name: 'create-account',
      path: '/accounts/create',
    },
    view: {
      name: 'view-account',
      path: '/accounts/:id',
    },
    update: {
      name: 'update-account',
      path: '/accounts/:id/update',
    },
  },
  sensors: {
    name: 'sensors',
    path: '/sensors',
    view: {
      name: 'view-sensor',
      path: '/sensors/:id',
    },
  },
  meters: {
    name: 'meters',
    path: '/meters',
    create: {
      name: 'create-meter',
      path: '/meters/create',
    },
    view: {
      name: 'view-meter',
      path: '/meters/:id',
    },
    update: {
      name: 'update-meter',
      path: '/meters/:id/update',
    },
  },
  meterpoints: {
    name: 'meter-points',
    path: '/meter-points',
    create: {
      name: 'create-meter-point',
      path: '/meter-points/create',
    },
    view: {
      name: 'view-meter-point',
      path: '/meter-points/:id',
    },
    update: {
      name: 'update-meter-point',
      path: '/meter-points/:id/update',
    },
  },
  gateways: {
    name: 'gateways',
    path: '/gateways',
    createGateway: {
      name: 'create-gateway',
      path: '/gateways/create',
    },
    viewGateway: {
      name: 'view-gateway',
      path: '/gateways/:id',
    },
    updateGateway: {
      name: 'update-gateway',
      path: '/gateways/:id/update',
    },
  },
  unallocatedDevices: {
    name: 'unallocated-devices',
    path: '/unallocated-devices',
  },
  users: {
    name: 'users',
    path: '/users',
    create: {
      name: 'create-users',
      path: '/users/create',
    },
    view: {
      name: 'view-users',
      path: '/users/:id',
    },
    update: {
      name: 'update-users',
      path: '/users/:id/update',
    },
  },
  apiKeys: {
    name: 'api-keys',
    path: '/api-keys',
  },
  emailIntegrationLogs: {
    name: 'email-integration-logs',
    path: '/email-integration-logs',
  },
  tariffs: {
    name: 'tariffs',
    path: '/tariffs',
    create: {
      name: 'create-tariff',
      path: '/tariffs/create',
    },
    view: {
      name: 'view-tariff',
      path: '/tariffs/:id',
    },
    update: {
      name: 'update-tariff',
      path: '/tariffs/:id/update',
    },
  },
  recons: {
    name: 'recons',
    path: '/recons',
  },
  payments: {
    name: 'payments',
    path: '/payments',
  },
  invoices: {
    name: 'invoices',
    path: '/invoices',
    view: {
      name: 'view-invoice',
      path: '/invoices/:id',
    },
  },
  reports: {
    name: 'reports',
    path: '/reports',
  },
  map: {
    name: 'map',
    path: '/map',
  },
  integrations: {
    name: 'integrations',
    path: '/integrations',
  },
  manualReadings: {
    name: 'manual-data',
    path: '/manual-data',
    whitelists: {
      name: 'email-integration-whitelists',
      path: '/manual-data/whitelists',
    },
  },
  accounting: {
    name: 'accounting',
    path: '/accounting',
    view: {
      name: 'view-account',
      path: '/accounting/accounts/:id',
    },
  },
  financials: {
    name: 'financials',
    path: '/financials',
  },
  status: {
    root: 'status',
    unverified: {
      name: 'unverified',
      path: '/status/unverified',
    },
    unauthorized: {
      name: 'unauthorized',
      path: '/status/unauthorized',
    },
    statusComingSoon: {
      name: 'coming-soon',
      path: '/status/coming-soon',
    },
    statusMaintenance: {
      name: 'maintenance',
      path: '/status/maintenance',
    },
    status404: {
      name: '404',
      path: '/status/404',
    },
    status500: {
      name: '500',
      path: '/status/500',
    },
    statusSuccess: {
      name: 'success',
      path: '/status/success',
    },
    statusFailure: {
      name: 'failure',
      path: '/status/failure',
    },
    statusCancel: {
      name: 'cancel',
      path: '/status/cancel',
    },
  },
  design: {
    name: 'design',
    path: '/design',
    tokens: {
      name: 'design-tokens',
      path: '/design/tokens',
    },
    charts: {
      name: 'design-charts',
      path: '/design/charts',
    },
    bulkActions: {
      name: 'design-bulk-actions',
      path: '/design/bulk-actions',
    },
    bulkRename: {
      name: 'design-bulk-rename',
      path: '/design/bulk-rename',
    },
    ruleDialog: {
      name: 'design-rule-dialog',
      path: '/design/rule-dialog',
    },
  },
  providers: {
    name: 'providers',
    path: '/providers',
    create: {
      name: 'create-provider',
      path: '/providers/create',
    },
    view: {
      name: 'view-provider',
      path: '/providers/:id',
    },
  },
  topup: {
    root: 'topup',
    success: { name: 'success', path: '/topup/success' },
    error: { name: 'error', path: '/topup/error' },
    cancel: { name: 'cancel', path: '/topup/cancel' },
    return: { name: 'return', path: '/topup/return' },
  },
  releaseNotes: {
    name: 'release-notes',
    path: '/release-notes',
  },
  hardware: {
    name: 'hardware',
    path: '/hardware',
  },
};

export default pages;
